<div class="card-change-business">
  <div class="dialog-header">
    <div class="dialog-header-left">
      <div class="dialog-icon">
        <i class="fa-light"
          [ngClass]="{
            'fa-building': valueChange === 'name' || valueChange === 'description',
            'fa-link': valueChange === 'slug',
            'fa-map-marker-alt': valueChange === 'address',
            'fa-id-badge': valueChange === 'membership_title',
            'fa-comment-lines': valueChange === 'subscription_text',
            'fa-users': valueChange === 'capacity',
            'fa-file-contract': valueChange === 'general_conditions'
          }"></i>
      </div>
      <div>
        <p class="title-change">{{nameValue}}</p>
        <p class="subtitle-change">Actualizar información del espacio</p>
      </div>
    </div>
    <button class="btn-close-dialog" mat-dialog-close>
      <i class="fa-light fa-times"></i>
    </button>
  </div>

  <div>
    <form [formGroup]="changeForm">
      <div *ngIf="valueChange == 'name'">
        <p class="field-helper">Este nombre es el que verán los usuarios en la plataforma Citylok al buscar tu espacio.</p>
        <div class="bloque-change-input container-form d-flex align-items-center">
          <input class="w-100" type="text" placeholder="Nombre del espacio" formControlName="name" required>
        </div>
      </div>

      <div *ngIf="valueChange == 'slug'">
        <p class="field-helper">Personaliza la URL pública de tu espacio. Usa solo letras minúsculas, números y guiones.</p>
        <div class="bloque-change-input container-form d-flex align-items-center"
          [ngClass]="{ error: changeForm.get('slug')?.invalid && changeForm.get('slug')?.touched }">
          <input class="w-100" type="text" placeholder="mi-espacio-personalizado" formControlName="slug" required>
        </div>
        <p class="field-error-text"
           *ngIf="changeForm.get('slug')?.invalid && changeForm.get('slug')?.touched">
          Este campo es obligatorio.
        </p>
      </div>

      <div *ngIf="valueChange == 'capacity'">
        <p class="field-helper">Número máximo de personas permitidas en el espacio. Déjalo vacío si no hay límite.</p>
        <div class="bloque-change-input container-form d-flex align-items-center">
          <input class="w-100" type="number" min="1" placeholder="Ej: 500" formControlName="capacity">
        </div>
      </div>

      <div *ngIf="valueChange == 'membership_title'">
        <p class="field-helper">Define cómo se llaman los miembros de este espacio (ej. "Socios", "Abonados", "Miembros").</p>
        <div class="bloque-change-input container-form d-flex align-items-center">
          <input class="w-100" type="text" placeholder="Socios, Abonados, Miembros..." formControlName="membership_title" required>
        </div>
      </div>

      <div *ngIf="valueChange == 'subscription_text'">
        <p class="field-helper">Texto que se mostrará a los usuarios al invitarles a suscribirse a este espacio.</p>
        <div class="bloque-change-input container-form d-flex align-items-center">
          <input class="w-100" type="text" placeholder="Únete al espacio..." formControlName="subscription_text" required>
        </div>
      </div>

      <div *ngIf="valueChange == 'description'">
        <p class="field-helper">Describe tu espacio: instalaciones, capacidad, usos, etc. Esta descripción será visible para todos los usuarios.</p>
        <div class="bloque-change-input input-textarea container-form d-flex align-items-start">
          <textarea #textarea class="w-100" placeholder="Descripción del espacio..." maxlength="2500"
            formControlName="description"></textarea>
        </div>
      </div>

      <div *ngIf="valueChange == 'general_conditions'">
        <p class="field-helper">Define las condiciones generales de uso o contratación del espacio. Se mostrarán en la página pública.</p>
        <angular-editor formControlName="general_conditions" [config]="editorConfigVenue"></angular-editor>
      </div>

      <div *ngIf="valueChange == 'address'">
        <p class="field-helper">Introduce la dirección del espacio para que los usuarios puedan encontrarlo fácilmente.</p>
        <label class="input-label">Buscar ubicación</label>
        <mat-form-field appearance="fill" class="w-100 address-autocomplete-field">
          <i matPrefix class="fa-light fa-search address-search-icon"></i>
          <input id="searchMap" #search matInput type="text"
            placeholder="Calle, ciudad, código postal..."
            name="address" (input)="onSearchPlaces()" [(ngModel)]="lugar"
            [matAutocomplete]="auto" [ngModelOptions]="{standalone: true}">
          <mat-autocomplete (optionSelected)="onSelectPlace(search.value)" #auto="matAutocomplete"
            [displayWith]="displayFn">
            <mat-option *ngFor="let option of searchResults" [value]="option" class="item-option-map">
              <div class="item-option">
                <i class="fa-solid fa-location-dot"></i>
                <span>{{option.description}}</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div *ngIf="changeForm.value.address" class="selected-address-box">
          <i class="fa-light fa-location-dot"></i>
          <span>{{changeForm.value.address}}</span>
        </div>
      </div>

      <div class="d-flex gap-2 justify-content-center btn-change">
        <button class="primary-button solid w-50" style="min-height: 40px;"
          (click)="changeBusiness()">Guardar</button>
      </div>
    </form>
  </div>
</div>
